module.exports = __webpack_public_path__ + "img/christin-hume-Hcfwew744z4-unsplash.c7c11b26.jpg";